import { refreshBulkUploadSessionId } from '@Actions/bulkUpload';
import { AnyAction, createReducer } from '@reduxjs/toolkit';
import { BulkUploadStoreState } from '@Types/bulkUpload.types';

export const initialState: BulkUploadStoreState = {
	sessionId: '',
};

interface BulkUploadReducer {
	[x: string]: (
		state: BulkUploadStoreState,
		action: AnyAction,
	) => BulkUploadStoreState | undefined | void;
}

const reducer: BulkUploadReducer = {
	[refreshBulkUploadSessionId.toString()]: state => {
		state.sessionId = `session-id-${Date.now()}`;
	},
};

export default createReducer(initialState, reducer);
